import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=68119616&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=68119616&prod&scoped=true&lang=scss"
import style1 from "./CardItem.vue?vue&type=style&index=1&id=68119616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68119616",
  null
  
)

export default component.exports